/* Visor de documentos de la seccion de estandares (dialog nativo, teclado y gestos) */
(function () {
  function init() {
    var root = document.querySelector('.lp-std');
    if (!root) return;
    var dlg = root.querySelector('.lp-std__dialog');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var items = [].slice.call(root.querySelectorAll('.lp-doc'));
    var img = dlg.querySelector('img'), cap = dlg.querySelector('figcaption');
    var cur = 0, startX = null, opener = null;
    function show(i) {
      cur = (i + items.length) % items.length;
      var b = items[cur];
      img.src = b.getAttribute('data-src');
      img.alt = b.getAttribute('data-title');
      cap.textContent = b.getAttribute('data-title') + '  ·  ' + (cur + 1) + ' / ' + items.length;
      img.style.animation = 'none'; void img.offsetWidth; img.style.animation = '';
    }
    items.forEach(function (b, i) {
      b.addEventListener('click', function () { opener = b; show(i); dlg.showModal(); document.documentElement.style.overflow = 'hidden'; });
    });
    dlg.querySelector('.lp-std__nav--prev').addEventListener('click', function () { show(cur - 1); });
    dlg.querySelector('.lp-std__nav--next').addEventListener('click', function () { show(cur + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.tagName === 'FIGURE') dlg.close(); });
    dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; if (opener) opener.focus(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(cur + 1);
      if (e.key === 'ArrowLeft') show(cur - 1);
    });
    dlg.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX; startX = null;
      if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
